// import autobind from 'core-decorators/lib/autobind';
import React from 'react';
import autoBind from 'react-autobind'
import withRouter from "react-router-dom/withRouter";
import { Link } from 'react-router-dom'
import data from '../data.json'


class Navigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      linkState: [false, false, false, false, false, false, false],
      lastId: 1,
      subLinks: false,
    };
    autoBind(this);
  }

  componentDidMount(){
    var loc = window.location.pathname;
    var e = 0;
    if(loc === "/cars"){
      e = 1;
    } else if(loc === "/about"){
      e = 2;
    } else if(loc === "/history"){
      e = 3;
    } else if(loc === "/team"){
      e = 4;
    } else if(loc === "/contact"){
      e = 5;
    } else if(loc === "/press"){
      e = 6;
    } else {
      e = 0;
    }
    var array = this.state.linkState;
    array[this.state.lastId] = false;
    array[e] = true;
    this.setState({linkState: [...array], lastId: e })
  }


  handleClick(e){
    var array = this.state.linkState;
    array[this.state.lastId] = false;
    array[e] = true;
    this.setState({linkState: [...array], lastId: e })
  }
  subLinksChange(){
    this.setState({subLinks: !this.state.subLinks});
  }
  subLinksOpen(){
    this.setState({subLinks: true});
  }
  subLinksClose(){
    this.setState({subLinks: false});
  }


  render() {
    const linkState1 = this.state.linkState[1] ? "navigationlinkActive" : null;
    // const linkState2 = this.state.linkState[2] ? "navigationlinkActive" : null;
    const linkState3 = this.state.linkState[3] ? "navigationlinkActive" : null;
    const linkState4 = this.state.linkState[4] ? "navigationlinkActive" : null;
    const linkState5 = this.state.linkState[5] ? "navigationlinkActive" : null;
    const linkState6 = this.state.linkState[6] ? "navigationlinkActive" : null;
    // const linkState7 = this.state.linkState[7] ? "navigationlinkActive" : null;
    



    // const subLinksWrapperState = this.state.subLinks ? styles.subLinksWrapperOpen : styles.subLinksWrapperClose;
        

    return (
      <div className="navigationWrapper">

        <div className="navigationFirstChild">
          <Link to="/" className="navigationImgWrapper">
            <img alt="logoW" src="../assets/icons/logoW.png" className="navigationImg" />
          </Link>
          <div className="navigationLinksWrapper">
            <div 
            className={"navigationLink " +linkState1} 
              onClick={()=> {
                this.subLinksClose();
                var id=1;
                this.handleClick(id);
                window.scrollTo(0,0);
                if(this.props.onClose)this.props.onClose();
                setTimeout(() => {
                  this.props.history.push("/cars");
                }, 500);
              }}
            
            >
              CARS
            </div>
            {/*<div
              className={"navigationLink " +linkState2} 
              onClick={()=> {
                this.subLinksChange();
                var id=2;
                this.handleClick(id);
                window.scrollTo(0,0);
                
                setTimeout(() => {
                  this.props.history.push("/about");
                }, 500)
              }}
            >
              ABOUT
            </div>*/}
            <div
              className={"navigationLink " +linkState3} 
              onClick={()=> {
                this.subLinksClose();
                var id=3;
                this.handleClick(id);
                window.scrollTo(0,0);
                if(this.props.onClose)this.props.onClose();
                setTimeout(() => {
                  this.props.history.push("/history");
                }, 500)
              }}
            >
              HISTORY
            </div>
            {data.pages[7].Published ?
              <div
                className={"navigationLink " +linkState4} 
                onClick={()=> {
                  this.subLinksClose();
                  var id=4;
                  this.handleClick(id);
                  window.scrollTo(0,0);
                  if(this.props.onClose)this.props.onClose();
                  setTimeout(() => {
                    this.props.history.push("/team");
                  }, 500)
                }}
              >
                TEAM
              </div>
            :
              null
            }
            <div
              className={"navigationLink " +linkState5} 
              onClick={()=> {
                this.subLinksClose();
                var id=5;
                this.handleClick(id);
                window.scrollTo(0,0);
                if(this.props.onClose)this.props.onClose();
                setTimeout(() => {
                  this.props.history.push("/contact");
                }, 500)
              }}
            >
              CONTACT
            </div>
            <div
              className={"navigationLink " +linkState6} 
              onClick={()=> {
                this.subLinksClose();
                var id=6;
                this.handleClick(id);
                window.scrollTo(0,0);
                if(this.props.onClose)this.props.onClose();
                setTimeout(() => {
                  this.props.history.push("/press");
                }, 500)
              }}
            >
              PRESS
            </div>
          </div>
          <div className="navigationSocialWrapper">
            <a href="https://www.facebook.com/TushekCars/" className="navigationSocialLinkWrapper">
              <img alt="" src="/assets/icons/facebook.png" className="navigationSocialImg" />
              <div className="navigationSocialText">tushek_supercars</div>
            </a>
          </div>
          <div className="navigationSocialWrapper">
            <a href="https://www.youtube.com/channel/UCDjdCJQR7KsFJ-zdXyDnRaQ" className="navigationSocialLinkWrapper">
              <img alt="" src="/assets/icons/youtube.png" className="navigationSocialImg" />
              <div className="navigationSocialText">Tushek Supercars</div>
            </a>
          </div>
          <div className="navigationSocialWrapper">
            <a href="https://www.instagram.com/tushek_supercars/" className="navigationSocialLinkWrapper">
              <img alt="" src="/assets/icons/instagram.png" className="navigationSocialImg" />
              <div className="navigationSocialText">tushek_supercars</div>
            </a>
          </div>
        </div>
        
      </div>
    );
  }
}



export default withRouter(Navigation);



// WEBPACK FOOTER //
// ./src/components/Navigation.js